module.exports = __webpack_public_path__ + "img/ganan_no.0820df73.png";